import { render } from "./CadastroComGrid.vue?vue&type=template&id=34a352a0&scoped=true&ts=true"
import script from "./CadastroComGrid.vue?vue&type=script&lang=ts"
export * from "./CadastroComGrid.vue?vue&type=script&lang=ts"

import "./CadastroComGrid.vue?vue&type=style&index=0&id=34a352a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a352a0"]])

export default __exports__